export const getExperimentsTableDataState = (state: Record<string, any>) =>
  state.experiments.index.tableData;
